import { css } from "@linaria/core";

import { TABLET_BREAKPOINT_PX } from "../../../../styles/constants";
import { breakpointDownMixin } from "../../../../styles/mixins/breakpoints";
import { verticalMarginMixin } from "../../../../styles/mixins/collapsableMargin";
import { listReset } from "../../../../styles/resets";
import { headerPaddingProp } from "../../../../styles/variables";

const underlineOffsetProp = "--underline-offset";

export const stickyCls = css`
  ${underlineOffsetProp}: 3rem;

  padding: 4.5rem 3rem 4.5rem
    calc(var(${headerPaddingProp}) - var(${underlineOffsetProp}));

  box-sizing: border-box;
  max-height: 100%;
  width: calc(100% - var(--margin-left));

  overflow-y: auto;
`;

export const activeUnderlineCls = css`
  /** custom styling of underline */
  &::after {
    width: 2px;
    border-radius: 1px;
  }
`;

export const listCls = css`
  ${listReset};
`;

export const itemCls = css`
  ${verticalMarginMixin("1rem")};

  position: relative;
  padding-left: var(${underlineOffsetProp});

  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    margin: 0;
  }
`;
